import { gql } from "@apollo/client";

export const GET_JUSTIFICACION_PERIODO_FACTURAR = gql`
    query GetJustificacionPendienteFacturar {
        justificacionPendienteFacturar {
            idJustificacion,
            justificacion
        }
    }
`;

export const adaptJustificacionPeriodoFacturar = (justificacion) => {
  return {
    idJustificacion: justificacion?.idJustificacion,
    justificacion: justificacion?.justificacion
  };
};

export const adaptJustificacionPeriodoFacturarArray = (justificaciones) => {
  return structuredClone(justificaciones)?.
  map((justificacion) => adaptJustificacionPeriodoFacturar(justificacion));
};